<template>
  <admin-limits v-if="isAdmin" />
  <company-limits-page v-else />
</template>

<script>
import AdminLimits from "./AdminLimits.vue";
import CompanyLimitsPage from "./CompanyLimits.vue";

export default {
  name: "CompanyLimits",
  components: { AdminLimits, CompanyLimitsPage },
  computed: {
    isAdmin() {
      return this.$store.state.user?.user?.type === "admin";
    },
  },
};
</script>